import * as types from './types';

export default {
  updatePageContent: (payload) => ({ type: types.UPDATE_PAGE_CONTENT, payload }),
  editPageSettings: (payload) => ({ type: types.EDIT_PAGE_SETTINGS, payload }),
  changePageSettings: (payload) => ({ type: types.CHANGE_PAGE_SETTING, payload }),
};
